import { type RefObject, useLayoutEffect } from 'react'

const isDialogNotSupported = window.HTMLDialogElement === undefined

export function useDialogPolyfill(ref: RefObject<HTMLDialogElement>) {
	useLayoutEffect(() => {
		if (isDialogNotSupported && ref.current) {
			const dialog = ref.current
			import('dialog-polyfill').then(({ default: polyfill }) =>
				polyfill.registerDialog(dialog)
			)
		}
	}, [ref])
}
